import React from 'react';
import {Title, TitleLevel, TitleSize} from 'components/ui/Title';
import Container from 'components/layout/Container';

import './Steps.scss';

const Steps = () => {
  return (
    <section className="steps">
      <Container>
        <Title
          extraClassName="steps__title"
          level={TitleLevel.H2}
          size={TitleSize.H2}
        >
          Этапы и&nbsp;оплата
        </Title>

        <div className="steps__list">
          {[
            {
              title: <>Вы&nbsp;оставляете заявку</>,
              desctiption: (
                <>
                  Менеджер перезвонит вам и уточнит детали. Подберёт
                  архитектора.
                </>
              ),
            },
            {
              title: <>Архитектор делает проект</>,
              desctiption: (
                <>
                  Обсудит ваши пожелания, подготовит все документы для нужного
                  типа ремонта и составит подробную смету.
                </>
              ),
            },
            {
              title: <>Мы&nbsp;подбираем бригаду</>,
              desctiption: (
                <>
                  Предложим несколько бригад на&nbsp;выбор. У&nbsp;каждой
                  из&nbsp;них есть персональные странички с&nbsp;отзывами
                  и&nbsp;примерами работ.
                </>
              ),
            },
            {
              title: <>Бригада делает ремонт</>,
              desctiption: (
                <>
                  В&nbsp;чётком соответствии с&nbsp;проетом. За&nbsp;этим
                  на&nbsp;протяжении всего ремонта будет следить архитектор.
                </>
              ),
            },
            {
              title: <>Вы&nbsp;оплачиваете работу</>,
              desctiption: (
                <>
                  После окончания всех работ. Вы&nbsp;можете оплатить ремонт
                  наличными или переводом на&nbsp;карту бригадиру.
                </>
              ),
            },
          ].map((item, index) => (
            <div key={index} className="steps__item">
              <span
                className={`steps__item-index steps__item-index_${index + 1}`}
              >
                {index + 1}
                <span>.</span>
              </span>

              <div className="steps__item_right">
                <p className="steps__item-title">{item.title}</p>
                <p className="steps__item-desctiption">{item.desctiption}</p>
              </div>
            </div>
          ))}
        </div>
      </Container>
    </section>
  );
};

export default Steps;
